var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLargeBaggage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 26,
    viewBox: "0 0 18 26",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.588 6.578v16.343a2.537 2.537 0 0 0 2.316 2.523V4.056A2.535 2.535 0 0 0 .588 6.578m12.785-2.546V.637A.636.636 0 0 0 12.738 0H5.52a.637.637 0 0 0-.637.637v3.395H4.32V25.47h.408V26h1.167v-.532h6.47V26h1.167v-.532h.408V4.032zM6.158 1.273h5.939v2.76H6.158zm11.513 5.305a2.53 2.53 0 0 0-2.314-2.523h-.004v21.39a2.537 2.537 0 0 0 2.317-2.523V13.59l.002-.002v-7.01"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLargeBaggage);
export default __webpack_public_path__ + "static/media/largeBaggage.5bec6041ed7cfad94f830f130c90cc0b.svg";
export { ForwardRef as ReactComponent };